import React, { FC } from "react";
import "./input.css";

interface InputProps {
  label: any;
 
}
const Input: FC<InputProps & React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>> = ({ label, ...inputProps }) => {
  return (
    <div className="input-wrapper">
      <label htmlFor={inputProps.name}>{label}</label>
      {inputProps.type !== "textarea" ? <input {...inputProps}/> : <textarea rows={4} {...inputProps}></textarea>}
    </div>
  );
};

export default Input;
